import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import { formErrorMessage } from './FormErrorMessage';
import NewCloseIcon from '../svgIcons/NewCloseIcon';
import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import StyledNewTagsSearch from '../select/StyledNewTagsSearch';
import StyledText from '../styledComponents/StyledText';


const FormikNewTagsSearch = ({
  name,
  options,
  secondName,
  previousData,
  placeholder,
  setOptions,
  submitForm = () => {},
  isMulti = true,
  isArrayValues = false,
  disableSetNameField = false,
  arrayIndex,
  isFullWidth,
  onChange,
  removeProduct = () => {},
  ...props
}) => {
  const nameValue = placeholder ? placeholder?.replace(/\s+/g, '') : '';
  return (
    <Field name={name} {...props} key={name}>
      {({ form: { setFieldValue, values } }) => {
        const finalName = isArrayValues ? `${arrayIndex}.${name}` : name;

        const finalSecondName = isArrayValues
          ? `${arrayIndex}.${secondName}`
          : secondName;
        const finalValues = isArrayValues
          ? values[arrayIndex]?.[secondName]
          : values[secondName];
        return (
          <>
            <Row>
              <Col xs={12} md={isFullWidth ? 12 : 6}>
                <StyledNewTagsSearch
                  name={nameValue}
                  options={options?.map((option) => {
                    return {
                      ...option,
                      enabled: isMulti
                        ? finalValues?.find((_v) => _v.id === option.id)
                        : finalValues?.id === option.id,
                    };
                  })}
                  finalValues={finalValues}
                  isMulti={isMulti}
                  onChange={(v) => {
                    if (
                      finalValues &&
                      isMulti &&
                      !finalValues?.some((_v) => _v.id === v.id)
                    ) {
                      setFieldValue(finalSecondName, [
                        ...(finalValues ?? previousData[secondName] ?? []),
                        v,
                      ]);
                    }

                    if (isMulti && !finalValues) {
                      setFieldValue(finalSecondName, [v]);
                    }

                    if (!isMulti) {
                      setFieldValue(finalSecondName, v);
                    }

                    let cloneOptions = [...options];
                    const index = cloneOptions.findIndex(
                      (item) => item.id === v.id,
                    );

                    if (
                      finalValues &&
                      isMulti &&
                      finalValues?.some((_v) => _v.id === v.id)
                    ) {
                      const filteredOptions = finalValues?.filter(
                        (_v) => _v.id !== v.id,
                      );

                      typeof removeProduct === 'function' &&
                        removeProduct({
                          id: cloneOptions[index]?.id,
                          name: cloneOptions[index]?.name,
                        });
                      setFieldValue(finalSecondName, filteredOptions);
                      setOptions(cloneOptions);
                      !disableSetNameField && setFieldValue(finalName, '');
                      submitForm();
                      onChange && onChange(v);
                    } else {
                      cloneOptions[index] = {
                        ...cloneOptions[index],
                        enabled: true,
                      };
                      setOptions(cloneOptions);
                      !disableSetNameField && setFieldValue(finalName, '');
                      onChange && onChange(v);
                    }
                  }}
                  placeholder={placeholder}
                />
              </Col>
            </Row>

            <ErrorMessage name={secondName} render={formErrorMessage} />

            {finalValues?.length > 0 && (
              <Row>
                <SelectedTagsContainer className="mb-2 my-3 gap-1">
                  <StyledText color="bodyMedium" $fontSize="16px">
                    All Selected Tags:
                  </StyledText>
                    {finalValues?.map((v, index) => (
                  <StyledTags style={{
                    margin: 0
                  }}>
                      <span
                        className="me-2 singletag gap-2"
                        key={`${name}-${v.id}`}
                      >
                        {v.name}
                        <NewCloseIcon
                          onClick={() => {
                            const filteredOptions = finalValues?.filter(
                              (_v) => _v.id !== v.id,
                            );
                            let cloneOptions = [...options];
                            const index = cloneOptions.findIndex(
                              (item) => item.id === v.id,
                            );
                            cloneOptions[index] = {
                              ...cloneOptions[index],
                              enabled: !cloneOptions[index]?.enabled,
                            };
                            typeof removeProduct === 'function' &&
                              removeProduct({
                                id: cloneOptions[index]?.id,
                                name: cloneOptions[index]?.name,
                              });
                            setFieldValue(finalSecondName, filteredOptions);
                            setOptions(cloneOptions);
                            !disableSetNameField &&
                              setFieldValue(finalName, '');
                            submitForm();
                            onChange && onChange();
                          }}
                          className={'align-self-center cursor-pointer'}
                        />
                      </span>
                  </StyledTags>
                    ))}
                </SelectedTagsContainer>
              </Row>
            )}
          </>
        );
      }}
    </Field>
  );
};
FormikNewTagsSearch.propTypes = {
  name: Proptypes.string.isRequired,
  type: Proptypes.string,
  placeholder: Proptypes.string,
};
const StyledTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
  .singletag {
    margin: 5px 0;
    padding: 4px 6px 4px 12px;
    font-size: 14px;
    color: ${({ theme }) => theme.white};
    font-family: ${(theme) => theme.fontFamily};
    border: 1px solid ${({ theme }) => theme.dark40};
    background-color: ${({ theme }) => theme.badgeText};
    display: flex;
    flex-wrap: wrap;
    align-self: center;
    border-radius: 20px;
  }
`;

const SelectedTagsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  p {
    margin: 0;
  }
`;

export default FormikNewTagsSearch;